// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__YkuQZ","fullWidth":"Container_fullWidth__RIo6p","sm":"Container_sm__Oek_2"};